<template lang="pug">
.sv-input-list
    .sv-input-list__item(
        v-for="(value, index) in valuesWithEmpty"
        :key="index"
    )
        SvInput(
            color="graylight"
            :placeholder="placeholder"
            :value="value"
            :withIcon="false"
            :class="{ 'sv-input-list--with-remove': value }"
            @input="(v) => changeValue(v, index)"
        )

        SvButton.sv-input-list__icon(
            v-if="value !== null"
            icon
            :prependIcon=`{
                icon: 'trash',
                width: 20,
                height: 20,
                default: '#B7BAC6',
                hover: '#1993EB'
            }`
            view="primary-icon"
            @click="removeItem(value, index)"
        )
</template>

<script>
import SvIcon from '@/components/uikit/SvIcon.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';

export default {
  name: 'SvInputList',

  model: {
    prop: 'values',
    event: 'change',
  },

  components: {
    SvInput,
    SvIcon,
    SvButton,
  },

  props: {
    values: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: ''
    }
  },

  computed: {
    valuesWithEmpty() {
      return [...this.values.filter(v => v), null];
    },
  },

  methods: {
    changeValue(value, index) {
      const copyValues = [...this.values];
      copyValues.splice(index, 1, value);
      this.$emit('change', copyValues);
    },

    removeItem(value, index) {
      const tempArray = [...this.values];
      tempArray.splice(index, 1);
      this.$emit('change', tempArray);
    },
  },
};
</script>

<style lang="scss">
.sv-input-list__item {
    display: flex;
    width: 100%;
}

.sv-input-list--with-remove {
    margin-right: 10px;
    margin-bottom: 15px;
}

.sv-input-list__icon {
    margin-right: -50px;
}
</style>
